import { CharacterGenerateResponse } from '../../types/character';

export const generateCharacterModel = (response: CharacterGenerateResponse): CharacterGenerateResponse => response;
